import { useTradeSettingsStore } from '@/stores/tradeSettingsStore'
import { computed, type Ref } from 'vue'

export const useAverageSpreadSettings = (root: Ref<string | null>) => {
  const tradeSettingsStore = useTradeSettingsStore()
  const avgSpread = computed({
    get: () =>
      root.value ? (tradeSettingsStore.getSetting(root.value, 'avgSpread') ?? null) : null,
    set: (value) => {
      if (root.value) {
        tradeSettingsStore.setSetting(root.value, 'avgSpread', value)
      }
    },
  })
  const spreadStd = computed({
    get: () =>
      root.value ? (tradeSettingsStore.getSetting(root.value, 'spreadStd') ?? null) : null,
    set: (value) => {
      if (root.value) {
        tradeSettingsStore.setSetting(root.value, 'spreadStd', value)
      }
    },
  })
  const recAvgSpread = computed({
    get: () =>
      root.value ? (tradeSettingsStore.getSetting(root.value, 'recAvgSpread') ?? null) : null,
    set: (value) => {
      if (root.value) {
        tradeSettingsStore.setSetting(root.value, 'recAvgSpread', value)
      }
    },
  })
  const autoAvgSpread = computed({
    get: () =>
      root.value ? (tradeSettingsStore.getSetting(root.value, 'autoAvgSpread') ?? false) : false,
    set: (value) => {
      if (root.value) {
        tradeSettingsStore.setSetting(root.value, 'autoAvgSpread', value)
      }
    },
  })
  return {
    avgSpread,
    recAvgSpread,
    autoAvgSpread,
    spreadStd,
  }
}
